import React from "react";
import PropTypes from "prop-types";

const STATUS_CLASS = {
  ACCEPTED: "timeline-item--accepted",
  REJECTED: "timeline-item--rejected",
  accept: "timeline-item--accepted",
  reject: "timeline-item--rejected",
};

const Timeline = ({ timeline }) => {
  if (!timeline?.length) return null;

  return (
    <section aria-labelledby="timeline-heading">
      <h4 id="timeline-heading" className="mb-4 font-weight-bold">
        Timeline
      </h4>

      <ul className="timeline">
        {timeline.map((step, index) => {
          const statusClass = STATUS_CLASS[step.status] || "";

          return (
            <li key={index} className={`timeline-item ${statusClass}`}>
              <div className="timeline-marker" aria-hidden="true" />

              <div className="timeline-content">
                <h5 className="timeline-title">{step.title}</h5>

                {step.comments && (
                  <p className="timeline-text">{step.comments}</p>
                )}
                {step.payloadID && (
                  <p className="timeline-text">Payload ID: {step.payloadID}</p>
                )}
                {step.externalQuoteRequestID && (
                  <p className="timeline-text">
                    External Quote Request ID: {step.externalQuoteRequestID}
                  </p>
                )}
                {step.amazonRequestID && (
                  <p className="timeline-text">
                    Amazon Request ID: {step.amazonRequestID}
                  </p>
                )}
                {step.amazonQuoteID && (
                  <p className="timeline-text">
                    Amazon Quote ID: {step.amazonQuoteID}
                  </p>
                )}
                {step.poPayloadID && (
                  <p className="timeline-text">
                    PO Payload ID: {step.poPayloadID}
                  </p>
                )}
                {step.poOrderID && (
                  <p className="timeline-text">PO Order ID: {step.poOrderID}</p>
                )}
                {step.poResponsePayloadID && (
                  <p className="timeline-text">
                    PO Response Payload ID: {step.poResponsePayloadID}
                  </p>
                )}

                {step.items?.length > 0 && (
                  <ul className="timeline-subitems">
                    {step.items.map((item, i) => (
                      <li
                        key={i}
                        className={`timeline-subitem ${
                          STATUS_CLASS[item.status] || ""
                        }`}
                      >
                        Lineitem {i + 1}: {item.comments || item.status}
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

Timeline.propTypes = {
  timeline: PropTypes.array.isRequired,
};

export default Timeline;
